import React from "react";
import MenuJson from "../../config/menu";
import MenuSideBarContainer from "../../components/layout/MenuSideBarContainer";
import Logout from "../../components/layout/LogoutButton";
import { getInfoUser } from "../../util/auth";
import "./Menunew.css";
const Menu = () => {
  const data = JSON.parse(getInfoUser());
  const permissions = JSON.parse(
    data.company_hieararchy_json_permissons
  ).permissions;
  const codes = permissions.map((o) => o["code"]);

  function focusFunction() {
    document.getElementById("flex").style.backgroundColor = "yellow";
  }
  return (
    <div>
      <aside
        id="sideBar"
        className=" h-screen fixed sidebar z-20 mt-20 hideSideEl w-80 shadow-xl focus:outline-none focus:ring focus:ring-violet-300"
      >
        <div className="flex flex-col ">
          <div>
            {MenuJson.map((i) => {
              if (
                codes.includes(i.permission_code) ||
                i.permission_code === null
              ) {
                return (
                  <MenuSideBarContainer
                    key={i.name}
                    name={i.name}
                    parent={i.parent}
                    child={i.child}
                    icon={i.icon}
                    onFocus={focusFunction}
                  />
                );
              }
            })}
          </div>
        </div>
        <div className="logout">
          <Logout />
        </div>
      </aside>
    </div>
  );
};

export default Menu;
